import {combineReducers} from 'redux';
import {taskReducer} from './taskReducer';

export const commonReducer = combineReducers({taskReducer:taskReducer});